export const PROCESSING_DISPATCH_API = Object.freeze({
  HESAB_PAYMENT: 'processing/hesabPayment',
  EPOINT_PAYMENT: 'processing/epointPayment',
  EPOINT_PAYMENT_AND_CARD_REGISTRATION: 'processing/epointPaymentAndCardRegistration',
  INCOMING_CARD_ACTIVE_PROVIDER: 'processingSettings/incomingCardProvider',
  EPOINT_CARD_ATTACHMENT: 'processing/epointCardAttachment',
  EPOINT_INCOMING_PAYMENT_COMMISSION: 'commission/epointIncomingPayment',
  EWALLET_CHANGE: 'wallet/change',
});
